import type { ReactNode } from 'react';
import { z } from 'zod';
import type {
  ExternalResource,
  ExternalResourceCoverImage,
} from '@/models/resources';
import { ResourceTypesLabels } from '@/models/resources';

export const defaultSchema = z.object({
  name: z
    .string({ message: 'Nome é obrigatório' })
    .min(1, 'Nome é obrigatório'),
  url: z.url({ message: 'URL é obrigatória' }),
  category: z.enum(ResourceTypesLabels, {
    message: 'Tipo de recurso é obrigatório',
  }),
});

export type FormData = z.infer<typeof defaultSchema>;

export interface ExternalResourceDialogProps {
  onClose: () => void;
  defaultValues?: ExternalResource;
  onSubmit: (data: ExternalResource) => void;
  customHeader?: ReactNode;
  schema?: z.ZodType<FormData>;
  // Only the learning path's external resources support a custom cover image
  // for now, so this stays opt-in to avoid changing the IDP activity flow,
  // which reuses this same dialog and whose backend doesn't support it yet.
  showCoverImage?: boolean;
}

export interface CoverImageFieldProps {
  coverImage: ExternalResourceCoverImage | null;
  onUpload: (image: string | null) => void;
  onRemove: () => void;
}

export interface ActionsProps {
  onSubmit: () => void;
  onClose: () => void;
}
